<template>
  <div>
    <v-pagination
      v-model="page"
      class="mb-2"
      :total-visible="15"
      :length="totalPages"
      @input="handlePaginationInput"
    />
    <div v-if="isLoading" class="text-xs-center">
      <v-progress-circular indeterminate color="primary" size="70"></v-progress-circular>
    </div>
    <div v-else class="post-list">
      <template v-for="item in items">
        <slot :item="item" />
      </template>
    </div>
  </div>
</template>

<script>
import powerbuyShopServicesApi from '@/api/powerbuy-post'
import { mapGetters } from 'vuex'

export default {
  provide() {
    return {
      published: () => this.published
    }
  },
  props: {
    published: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      items: [],
      total: 0,
      pagination: {
        offset: 0,
        limit: 10
      },
      isLoading: true
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    page: {
      get() {
        return Math.floor(this.pagination.offset / this.pagination.limit) + 1
      },
      set(value) {
        this.pagination.offset = (value - 1) * this.pagination.limit
      }
    },
    totalPages() {
      return Math.ceil(this.total / this.pagination.limit)
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      try {
        this.isLoading = true

        const response = await powerbuyShopServicesApi.getFacebookPosts({
          ...this.pagination,
          pageid: this.selectedBot.pageid,
          publish: this.published
        })

        if (response.status !== 200) return

        this.items = response.data.data
        this.total = Number(response.data.total)
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    reload(options = { reset: false }) {
      if (options.reset) {
        this.pagination.offset = 0
      }
      this.fetchItems()
    },
    handlePaginationInput(page) {
      this.page = page
      this.fetchItems()
    }
  }
}
</script>

<style lang="scss" scoped>
.post-list {
  > *:not(:first-child) {
    margin-top: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/FacebookPostManager/FacebookPostList.vue